export const SET_LOADING = "@app/SET_LOADING";
export const SET_SESSION = "@app/SET_SESSION";
export const SET_CLINIC = "@app/SET_CLINIC"
export const SET_QRC_TOKEN = "@app/SET_QRC_TOKEN"
export const CLEAR_SESSION = "@app/CLEAR_SESSION"
